
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeletePalyerModal = ({showDeleteModal, confirmDelete,handleClose, userId,handleConfirmPlayerDelete }) => {
  return (
    <Modal show={showDeleteModal} onHide={handleClose} centered>
      <Modal.Header >
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this Player?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose} style={{borderRadius: "10px"}}>
          Cancel
        </Button>
        <Button variant="danger" onClick={() => handleConfirmPlayerDelete(userId)} style={{borderRadius: "10px"}}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePalyerModal;
